export const buildInitialState = () => ({
  onboardingProcesses: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  accountMigrations: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  custodyTransfers: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  averagePriceRequests: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  feeBillingBatches: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  professionals: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  clientSwaps: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // Âncora de injeção do Hygen — `_templates/new/api/state.ejs.t` usa
  // `before: // {{NEXT}}` para inserir o próximo slice aqui. O SonarQube
  // lê como código comentado (`javascript:S125`); apagar quebraria
  // `npx hygen new api` neste store, e a mesma âncora existe em 31
  // arquivos do repo.
  // {{NEXT}}
})

export default buildInitialState()
